export enum FilterType {
  hospitals = "hospitals",
  ems = "ems",
  complaints = "complaints",
}
